// src/components/PropertiesSection.jsx
import React, { useState } from 'react';
import './PropertiesSection.css';

// Import images from assets
import property1 from '../assets/property1.jpg';

import property11BHK1 from '../assets/property1_1bhk1.jpg';
import property11BHK2 from '../assets/property1_1bhk2.jpg';
import property11BHK3 from '../assets/property1_1bhk3.jpg';
import property11BHK4 from '../assets/property1_1bhk4.jpg';
import property11BHK5 from '../assets/property1_1bhk5.jpg';
import property11BHK6 from '../assets/property1_1bhk6.jpg';
import property11BHK7 from '../assets/property1_1bhk7.jpg';


import property2 from '../assets/property2.jpg';

import property21BHK1 from '../assets/property2_1bhk1.jpg';
import property21BHK2 from '../assets/property2_1bhk2.jpg';
import property21BHK3 from '../assets/property2_1bhk3.jpg';
import property21BHK4 from '../assets/property2_1bhk4.jpg';
import property21BHK5 from '../assets/property2_1bhk5.jpg';
import property21BHK6 from '../assets/property2_1bhk6.jpg';
import property21BHK7 from '../assets/property2_1bhk7.jpg';
import property21BHK8 from '../assets/property2_1bhk8.jpg';
import property21BHK9 from '../assets/property2_1bhk9.jpg';
import property21BHK10 from '../assets/property2_1bhk10.jpg';
import property21BHK11 from '../assets/property2_1bhk11.jpg';


import property3 from '../assets/property3.jpg';
import kamala from '../assets/kamala.jpg'
import royal from '../assets/royal.jpg'

import property33BHK1 from '../assets/property3_3bhk1.jpg';
import property33BHK2 from '../assets/property3_3bhk2.jpg';
import property33BHK3 from '../assets/property3_3bhk3.jpg';
import property33BHK4 from '../assets/property3_3bhk4.jpg';
import property33BHK5 from '../assets/property3_3bhk5.jpg';
import property33BHK6 from '../assets/property3_3bhk6.jpg';
import property33BHK7 from '../assets/property3_3bhk7.jpg';
import property33BHK8 from '../assets/property3_3bhk8.jpg';
import property33BHK9 from '../assets/property3_3bhk9.jpg';


import property4 from '../assets/property4.jpg';

import property42BHK1 from '../assets/property4_2bhk1.jpg';
import property42BHK2 from '../assets/property4_2bhk2.jpg';
import property42BHK3 from '../assets/property4_2bhk3.jpg';
import property42BHK4 from '../assets/property4_2bhk4.jpg';
import property42BHK5 from '../assets/property4_2bhk5.jpg';
import property42BHK6 from '../assets/property4_2bhk6.jpg';


import property43BHK1 from '../assets/property4_3bhk1.jpg';
import property43BHK2 from '../assets/property4_3bhk2.jpg';
import property43BHK3 from '../assets/property4_3bhk3.jpg';
import property43BHK4 from '../assets/property4_3bhk4.jpg';
import property43BHK5 from '../assets/property4_3bhk5.jpg';
import property43BHK6 from '../assets/property4_3bhk6.jpg';
import property43BHK7 from '../assets/property4_3bhk7.jpg';

const properties = [
  {
    id: 1,
    name: 'Sai Residency',
    description: 'A luxurious stay with modern amenities.',
    image: property1,
    buttons: ['1BHK'],
    galleries: {
      '1BHK': [property11BHK2, property11BHK3, property11BHK6, property11BHK1,  property11BHK4, property11BHK5, property11BHK7],
    },
    links: {
      '1BHK': {
        airbnb: 'https://www.airbnb.co.in/rooms/31196763?guests=1&adults=1&s=67&unique_share_id=ddd76618-205e-4b66-ab7b-ef90d0faa1ba',
      },
    },
    location: 'https://maps.app.goo.gl/erqHaG4ZwV5apvse7?g_st=ic',
  },
  {
    id: 2,
    name: 'Sai Nilayam',
    description: 'Experience tranquility and comfort.',
    image: property2,
    buttons: ['1BHK'],
    galleries: {
      '1BHK': [property21BHK6, property21BHK7, property21BHK1, property21BHK2, property21BHK3, property21BHK4, property21BHK5, property21BHK8, property21BHK9, property21BHK10, property21BHK11],
    },
    links: {
      '1BHK': {
        airbnb: 'https://www.airbnb.co.in/rooms/1199247151745943732?guests=1&adults=1&s=67&unique_share_id=a61e2959-6852-41e5-983c-a3815d92a384',
      },
    },
    location: 'https://maps.app.goo.gl/WrQm1uEpMvyjA6qq5?g_st=ic',
  },
  {
    id: 3,
    name: 'Royal Apartment',
    description: 'Perfect for family vacations.',
    image: kamala,
    buttons: ['3BHK'],
    galleries: {
      '3BHK': [property33BHK1, property33BHK2, property33BHK3, property33BHK4, property33BHK5, property33BHK6, property33BHK7, property33BHK8, property33BHK9],
    },
    links: {
      '3BHK': {
        airbnb: 'https://www.airbnb.co.in/rooms/557062417395125270?guests=1&adults=1&s=67&unique_share_id=17988e1f-dfd2-469d-b0bd-2070953ed27b',
      },
    },
    location: 'https://maps.app.goo.gl/aanRJJ4213djzfut9?g_st=ic',
  },
  {
    id: 4,
    name: 'Kamala Mansion',
    description: 'Affordable luxury in a prime location.',
    image: royal,
    buttons: ['2BHK', '3BHK'],
    galleries: {
      '2BHK': [property42BHK2, property42BHK3, property42BHK4, property42BHK5, property42BHK6],
      '3BHK': [property43BHK1, property43BHK2, property43BHK3, property43BHK4, property43BHK5, property43BHK6, property43BHK7],
    },
    links: {
      '2BHK': {
        airbnb: 'https://www.airbnb.co.in/rooms/26381829?guests=1&adults=1&s=67&unique_share_id=85a90036-281a-4645-842a-4c98cdf357e1',
      },
      '3BHK': {
        airbnb: 'https://www.airbnb.co.in/rooms/25274435?guests=1&adults=1&s=67&unique_share_id=200e3c27-4dc2-44e4-96c3-536e8d86cba5',
      },
    },
    location: 'https://maps.app.goo.gl/ht4XzzDxsD6Xjh2v5?g_st=ic',
  },
];

const PropertiesSection = () => {
  const [selectedGallery, setSelectedGallery] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showGallery, setShowGallery] = useState(false);
  const [selectedLinks, setSelectedLinks] = useState({ airbnb: '' });

  const openGallery = (gallery, links) => {
    setSelectedGallery(gallery || []);
    setSelectedLinks(links);
    setCurrentIndex(0);
    setShowGallery(true);
  };

  const closeGallery = () => {
    setShowGallery(false);
    setSelectedGallery([]);
    setSelectedLinks({ airbnb: '' });
  };

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % selectedGallery.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + selectedGallery.length) % selectedGallery.length
    );
  };

  return (
    <div id="properties" className="properties-section">
      <h2>Our Properties</h2>
      <div className="property-options">
        {properties.map((property) => (
          <div key={property.id} className="property-option">
            <img src={property.image} alt={property.name} />
            <h3>{property.name}</h3>
            <p>{property.description}</p>
            <div className="buttons">
              {property.buttons.map((button, index) => (
                <button
                  key={index}
                  onClick={() => openGallery(property.galleries[button], property.links[button])}
                >
                  {button}
                </button>
              ))}
            </div>
            <button
              className="view-location"
              onClick={() => window.open(property.location, '_blank')}
            >
              View Location
            </button>
          </div>
        ))}
      </div>

      {showGallery && (
        <div className="gallery-overlay" onClick={closeGallery}>
          <div className="gallery-container" onClick={(e) => e.stopPropagation()}>
            <button className="close-gallery" onClick={closeGallery}>Close</button>
            <button className="prev-button" onClick={prevImage}>&#8592; Previous</button>
            <img
              src={selectedGallery[currentIndex]}
              alt={`Slide ${currentIndex + 1}`}
              className="modal-image"
            />
            <button className="next-button" onClick={nextImage}>Next &#8594;</button>
            <div className="property-links">
              <a href={selectedLinks.airbnb} target="_blank" rel="noopener noreferrer">
                Book on Airbnb
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertiesSection;
